"use client";
import Image, { StaticImageData } from "next/image";

interface SolutionLink {
  icon: string | StaticImageData;
  url: string;
  label: string;
}

interface SectionLinks {
  title: string;
  links: SolutionLink[];
}

interface AllSolutionsNavProps {
  solutionLinks: SolutionLink[];
  industriesLinks: SolutionLink[];
}

const AllSolutionsNav: React.FC<AllSolutionsNavProps> = ({
  solutionLinks,
  industriesLinks,
}) => {
  const sections: SectionLinks[] = [
    { title: "Solutions", links: solutionLinks },
    { title: "Industries", links: industriesLinks },
  ];

  return (
    <div className="mb-16 mt-1 h-[calc(100dvh-246px)] overflow-y-auto border-b-[0.25px] border-[#535252] pb-4 text-white">
      {sections.map((section, sectionIdx) => (
        <div key={sectionIdx} className="mb-4">
          <h3 className="mb-2 text-base font-semibold text-[#202020]">
            {section.title}
          </h3>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3 lg:grid-cols-4">
            {section.links.map((link, linkIdx) => (
              <a
                href={link.url}
                rel="noreferrer"
                key={linkIdx}
                className="mb-2 flex items-center gap-2 p-1 text-sm"
              >
                {link.icon && (
                  <Image
                    src={link.icon || ""}
                    alt={link.label || ""}
                    width={16}
                    height={16}
                    className=""
                  />
                )}
                <p className="text-sm font-normal text-[#202020]">
                  {link.label}
                </p>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AllSolutionsNav;
